<template>
  <div>
    <v-icon small v-if="value" color="green" class="d-flex justify-center">
      mdi-checkbox-marked-circle
    </v-icon>
    <v-icon small v-else color="red" class="d-flex justify-center">
      mdi-close-circle
    </v-icon>
  </div>
</template>

<script>

export default {
  name: 'CheckboxPermission',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
